let domain = window.location.hostname;
if (process.env.VUE_APP_AUTH_COOKIE_DOMAIN != undefined) {
  domain = process.env.VUE_APP_AUTH_COOKIE_DOMAIN;
}
import bugsnagclient from "@/plugins/bugsnag";
class MyStorage {
  // the promise returned from sync function
  static syncPromise = null;
  static accessToken = null;
  // set item with the key
  static setItem(key, value) {
    switch (parse(key)) {
      case "accessToken": //memory
        this.accessToken = value;
        return value;
      case "idToken": //storage
        setCookie(key, value, 30, domain);
        return value;
      case "deviceKey": //cookie
        setCookie(key, value, 30, domain);
        return value;
      case "refreshToken": //cookie
        setCookie(key, value, 30, domain);
        return value;
      case "clockDrift": //storage
        localStorage.setItem(key, value);
        return value;
      case "LastAuthUser": //cookie
        setCookie(key, value, 30, domain);
        return value;
      case "randomPasswordKey": //storage
        localStorage.setItem(key, value);
        return value;
      case "deviceGroupKey": //storage
        localStorage.setItem(key, value);
        return value;
      case "aws-amplify-federatedInfo": //storage
        localStorage.setItem(key, value);
        return value;
      case "userData": //storage
        localStorage.setItem(key, value);
        return value;
      case "amplify-signin-with-hostedUI": //storage
        localStorage.setItem(key, value);
        return value;
      default:
        bugsnagclient.notify(
          new Error(`Missing SET ${parse(key)} from Storage Class.`)
        );
    }
    return null;
  }
  // get item with the key
  static getItem(key) {
    // console.log("[AUTH] GET", parse(key));
    switch (parse(key)) {
      case "accessToken": //memory
        return this.accessToken;
      case "idToken": //storage
        return getCookie(key);
      case "deviceKey": //cookie
        // cookieCompare(key);

        return getCookie(key);
      case "refreshToken": //cookie
        // cookieCompare(key);

        // console.log("REFRESH TOKEN", key);
        return getCookie(key);
      case "clockDrift": //storage
        return localStorage.getItem(key);
      case "LastAuthUser": //cookie
        // cookieCompare(key);
        // console.log("GOT", getCookie(key));
        return getCookie(key);
      case "randomPasswordKey": //storage
        return localStorage.getItem(key);
      case "deviceGroupKey": //storage
        return localStorage.getItem(key);
      case "aws-amplify-federatedInfo": //storage
        return localStorage.getItem(key);
      case "userData": //storage
        return localStorage.getItem(key);
      case "amplify-signin-with-hostedUI": //storage
        return localStorage.getItem(key);
      default:
        bugsnagclient.notify(
          new Error(`Missing GET ${parse(key)} from Storage Class.`)
        );
    }
    return null;
  }
  // remove item with the key
  static removeItem(key) {
    switch (parse(key)) {
      case "accessToken": //memory
        return this.accessToken;
      case "idToken": //storage
        return deleteCookie(key, domain);
      case "deviceKey": //cookie
        return deleteCookie(key, domain);
      case "refreshToken": //cookie
        return deleteCookie(key, domain);
      case "clockDrift": //storage
        return localStorage.removeItem(key);
      case "LastAuthUser": //cookie
        return deleteCookie(key, domain);
      case "randomPasswordKey": //storage
        return localStorage.removeItem(key);
      case "deviceGroupKey": //storage
        return localStorage.removeItem(key);
      case "aws-amplify-federatedInfo": //storage
        return localStorage.removeItem(key);
      case "userData": //storage
        return localStorage.removeItem(key);
      case "amplify-signin-with-hostedUI": //storage
        return localStorage.removeItem(key);
      default:
        bugsnagclient.notify(
          new Error(`Missing REMOVE ${parse(key)} from Storage Class.`)
        );
    }
  }
  // clear out the storage
  static clear() {
    console.log("[AUTH]CLEAR");
    localStorage.clear();
    clear();
    // bugsnagclient.notify(new Error(`Missing CLEAR from Storage Class.`));
  }
  // If the storage operations are async(i.e AsyncStorage)
  // Then you need to sync those items into the memory in this method
  static sync() {
    if (!MyStorage.syncPromise) {
      MyStorage.syncPromise = new Promise((res, rej) => {
        res();
      });
    }
    return MyStorage.syncPromise;
  }
}
export default MyStorage;
function parse(key) {
  let split = String(key).split(".");
  return split.pop();
}
function setCookie(cname, cvalue, exdays, domain) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${cvalue};${expires};path=/;domain=${domain};SameSite=lax`;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function deleteCookie(cname, domain) {
  document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;;path=/;domain=${domain}`;
}
// function clearCookies(){
//   document.cookie
// }
// eslint-disable-next-line no-unused-vars
const clear = () => {
  var cookies = document.cookie.split(";");
  cookies.forEach(cookie => {
    let s = String(cookie).split(".");
    if (`${s[0]}`.trim() != "CognitoIdentityServiceProvider") {
      return;
    }
    console.log(
      "[CLEAR]",
      domain,
      s[0],
      "CognitoIdentityServiceProvider",
      `${s[0]}`.trim() != "CognitoIdentityServiceProvider"
    );
    document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${domain}`;
    document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  });
};

// eslint-disable-next-line no-unused-vars
function cookieCompare(key) {
  let cookies = document.cookie.split(";");
  cookies.forEach(cookie => {
    let s = String(cookie).split("=");
    console.info(
      `%c${s[0]} | %c${key}`,
      "color:red;font-size:14px;",
      "color:blue;font-size:14px;"
    );
  });
}
